import { create } from "zustand";

export const usePositionDebugStore = create((set) => ({
  debugPositions: [],

  addDebugPosition: (event) =>
    set((state) => {
      state.debugPositions.push(event);
      return state;
    }),

  clearDebugPositions: () =>
    set((state) => {
      state.debugPositions = [];
      return state;
    }),
}));